import React, { useEffect, useState } from 'react'

import { useNavigate, useParams } from "react-router-dom";
import { pageRoutes } from '../../routes/pageRoutes';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { APIServices } from '../../hooks/fetchAPI';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import { useDispatch } from 'react-redux';
import { storeUserDetails } from '../../redux/userSlice';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import { civilStatusOptions, experienceLevelOptions, genderOptions } from '../../contant';
import CircularProgress from '@mui/material/CircularProgress';
import { storageApi } from '../../contant';


import Button from '@mui/material/Button';
import AddressPicker from '../../component/AddressPicker';
import { GrUpdate } from 'react-icons/gr';

const TAS_BASE_URL = "https://611systems.com/api/tas/";
const TAS_AC = "611";
const TAS_AK = "546453435asd23asd143asdk23kj4h5y4gh23";

const RegisterPage = () => {
    const images = [];
    const { id } = useParams();

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = React.useState(false);
    const [showPassword2, setShowPassword2] = React.useState(false);
    const [confirmPassword, setConfirmPassword] = useState('');
    const [alertmsg, setAlertMsg] = useState('');
    const [branchOptions, setBranchOptions] = useState([]);
    const [getAds, fetchContent] = useState([]);
    const [imageSources, setImageSources] = useState(images);
    const [isLoading, setIsLoading] = useState(false);
    const [addressPickerOpen, setAddressPickerOpen] = useState(false);
    const [addressFieldToUpdate, setAddressFieldToUpdate] = useState(null);
    const [isSameAddress, setIsSameAddress] = useState(false);
    const [isSameParentAddress, setIsSameParentAddress] = useState(false);
    const [isSameEmergencyAddress, setIsSameEmergencyAddress] = useState(false);
    const [data, setData] = useState({});
    const [branch_id, setBranchId] = useState(localStorage.getItem("branch_id") || null);

    const [formValues, setFormValues] = React.useState({
        firstName: '',
        middleName: '',
        lastName: '',
        gender: '',
        civilStatus: '',
        birthDate: '',
        age: '',
        phoneNumber: '',
        currentAddress: '',
        permanentAddress: '',
        email: '',
        password: '',
        branch: '',
        experience_set: '',
        parents: {
            fatherName: '',
            motherMaidenName: '',
            homeAddress1: '',
        },
        emergencyContact: {
            name: '',
            contactNumber: '',
            address: ''
        },
        referralCode: '',
        jobPosition: '',
    });

    useEffect(() => {
        if (branch_id) {
            setFormValues(prev => ({
                ...prev,
                branch: branch_id
            }));
        }
    }, [branch_id]);



    useEffect(() => {

        const timer = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                prevIndex === imageSources.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(timer);
    }, [imageSources.length]);


    useEffect(() => {
        if (getAds.length > 0) {
            setImageSources(getAds.map(ad => `${storageApi}${ad.file}`));
        } else {
            setImageSources(images);
        }
    }, [getAds]);


    const adsContent = async () => {
        setIsLoading(true);
        try {
            const response = await APIServices.get({ url: `/show-ads` });
            if (response && response.status === 200) {
                fetchContent(response?.data || []);
            }
        } catch (error) {
            console.error("Failed to fetch ads content", error);
        } finally {
            setIsLoading(false);
        }
    }

    const getBranch = async () => {
        try {
            const response = await APIServices.get({ url: `/branches` });

            if (response && response.status === 200) {
                const branches = response?.data?.data.map(branch => ({
                    value: branch?.id,
                    label: branch?.name,
                    disabled: false
                }));
                setBranchOptions([{ value: '', label: 'Select branch...', disabled: true }, ...branches]);
            }
        } catch (error) {
            console.error("Error fetching branches:", error);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChangeExperienceSet = (e) => {
        const { name, value } = e.target;

        const selectedOption = experienceLevelOptions.find(
            opt => String(opt.id) === value
        );

        if (!selectedOption) return;

        setFormValues(prev => ({
            ...prev,
            [name]: {
                id: selectedOption.id,       // PRIMARY IDENTIFIER
                value: selectedOption.value, // backend value
                label: selectedOption.label, // display
            }
        }));
    };

    const handleParentsChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            parents: { ...prev.parents, [name]: value }
        }));
    };

    const handleEmergencyContactChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            emergencyContact: { ...prev.emergencyContact, [name]: value }
        }));
    };

    const handleOpenAddressPicker = (fieldName) => {
        setAddressFieldToUpdate(fieldName);
        setAddressPickerOpen(true);
    };

    const getFieldValue = (fieldName) => {
        if (fieldName.includes('.')) {
            const [parent, child] = fieldName.split('.');
            return formValues[parent]?.[child] || '';
        }
        return formValues[fieldName] || '';
    }


    const handleAddressSelect = (address) => {
        if (addressFieldToUpdate.includes('.')) {
            const [parent, child] = addressFieldToUpdate.split('.');
            setFormValues(prev => ({ ...prev, [parent]: { ...prev[parent], [child]: address } }));
        } else {
            setFormValues(prev => ({ ...prev, [addressFieldToUpdate]: address }));
        }
    };

    const handleSameParentAddressChange = (event) => {
        const checked = event.target.checked;
        setIsSameParentAddress(checked);
        if (checked) {
            setFormValues(prev => ({
                ...prev,
                parents: { ...prev.parents, homeAddress1: prev.currentAddress }
            }));
        }
    };

    const handleSameEmergencyAddressChange = (event) => {
        const checked = event.target.checked;
        setIsSameEmergencyAddress(checked);
        if (checked) {
            setFormValues(prev => ({
                ...prev,
                emergencyContact: { ...prev.emergencyContact, address: prev.currentAddress }
            }));
        }
    };

    const handleSameAddressChange = (event) => {
        const checked = event.target.checked;
        setIsSameAddress(checked);
        if (checked) {
            setFormValues(prev => ({ ...prev, permanentAddress: prev.currentAddress }));
        }
    };


    useEffect(() => {
        getBranch()
        adsContent()
    }, []);

    const calculateAge = (birthDate) => {
        const birthday = new Date(birthDate);
        const today = new Date();
        let age = today.getFullYear() - birthday.getFullYear();
        const m = today.getMonth() - birthday.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
            age--;
        }
        return age;
    }


    const checkApplicant = async () => {

        const requiredFields = {
            firstName: "First Name",
            middleName: "Middle Name",
            lastName: "Last Name",
            phoneNumber: "Phone Number",
            email: "Email",
        }

        for (const fieldPath in requiredFields) {
            const pathParts = fieldPath.split('.');
            let value = formValues;
            for (const part of pathParts) {
                value = value ? value[part] : undefined;
            }

            if (!value) {
                setAlertMsg({
                    type: 'error',
                    message: `Please fill out the "${requiredFields[fieldPath]}" field.`
                });
                return;
            }
        }

        const params = new URLSearchParams({
            act: 'fetch_user',
            ac: TAS_AC,
            ak: TAS_AK,
            fname: formValues.firstName,
            mname: formValues.middleName,
            lname: formValues.lastName,
            email: formValues.email,
            mobile_no: formValues.phoneNumber,
        });

        const response = await APIServices.get({
            url: `${TAS_BASE_URL}?${params.toString()}`,
        });

        const errorData = response?.data?.data;

        if (response.status === 200 && response?.data?.stat === "user_not_found") {
            setAlertMsg({
                type: 'info',
                message: 'Please continue filling out your registration.'
            });
            navigate(`/register/2`);

        } else if (response.status === 200 && response?.data?.stat === "ok") {
            setData(response?.data?.data || {});

            setFormValues(prev => ({
                ...prev,
                birthDate: data?.birthdate || '',
                civilStatus: data?.civilstatus || '',
                gender: data?.gender || '',
                currentAddress: data?.address || '',
                permanentAddress: data?.permanent_address || '',
                parents: {
                    ...prev.parents,
                    fatherName: data?.father_name || '',
                    motherMaidenName: data?.mother_name || '',
                    homeAddress1: data?.parent_address || '',
                },
            }));

            setAlertMsg({
                type: 'info',
                message: 'User Found: Please review and update your registration information.'
            });

            navigate(`/register/2`);
        }
        else if (response.status === 200 && response?.data?.stat === "data_mismatched") {
            setAlertMsg({
                type: 'warning',
                message: 'The name matches our records, but the email address or mobile number does not. Please verify your information or contact HR.'
            });
        } else if (response.status === 200 && response?.data?.stat === "user_is_active") {
            setAlertMsg({
                type: 'warning',
                message: 'This account is already associated with an active employee. Re-entry to the TAS system is not allowed. Please coordinate with HR if you believe this is an error.'
            });

        } else {
            setAlertMsg({
                type: "error",
                message:
                    errorData
                        ? Object.values(errorData).join(", ")
                        : response?.data?.statMsg ||
                        response[0]?.response?.data?.message ||
                        "An error occurred while checking applicant information.",
            });
        }
    }


    const submitForm = async () => {
        const requiredFields = {
            firstName: "First Name",
            lastName: "Last Name",
            gender: "Gender",
            civilStatus: "Civil Status",
            birthDate: "Birth Date",
            phoneNumber: "Phone Number",
            currentAddress: "Current Address",
            permanentAddress: "Permanent Address",
            experience_set: "Application Level",
            email: "Email",
            password: "Password",
            branch: "Branch",
            'parents.fatherName': "Father's Name",
            'parents.motherMaidenName': "Mother's Maiden Name",
            'parents.homeAddress1': "Parent's Home Address",
            'emergencyContact.name': "Emergency Contact Name",
            'emergencyContact.contactNumber': "Emergency Contact Number",
            'emergencyContact.address': "Emergency Contact Address",
        };

        if (parseFloat(formValues.experience_set?.id) === 5) {
            requiredFields.jobPosition = "Job Position";
        } else if (parseFloat(formValues.experience_set?.id) === 0) {
            setAlertMsg({
                type: 'error',
                message: "Please select a valid Application Level."
            });
            return;
        }

        if (calculateAge(formValues.birthDate) < 18) {
            setAlertMsg({
                type: 'error',
                message: "Applicant must be 18 years or older."
            });
            return;
        }

        for (const fieldPath in requiredFields) {
            const pathParts = fieldPath.split('.');
            let value = formValues;
            for (const part of pathParts) {
                value = value ? value[part] : undefined;
            }

            if (!value) {
                setAlertMsg({
                    type: 'error',
                    message: `Please fill out the "${requiredFields[fieldPath]}" field.`
                });
                return;
            }
        }

        if (formValues.phoneNumber.length !== 11) {
            setAlertMsg({
                type: 'error',
                message: "Phone number must be 11 digits."
            });
            return;
        }

        // Validate password match
        if (formValues.password !== confirmPassword) {
            setAlertMsg({
                type: 'error',
                message: 'Passwords do not match.'
            });
            return;
        }

        const payload = {
            first_name: formValues.firstName.toUpperCase(),
            middle_name: formValues?.middleName?.toUpperCase() || "",
            last_name: formValues.lastName.toUpperCase(),
            email: formValues.email,
            password: formValues.password,
            user_branch_id: formValues.branch || null,
            gender: formValues.gender,
            civil_status: formValues.civilStatus,
            birthday: formValues.birthDate,
            experience_set: formValues.experience_set?.value,
            age: calculateAge(formValues.birthDate),
            contact_number: formValues.phoneNumber,
            current_address: formValues.currentAddress.toUpperCase(),
            permanent_address: formValues.permanentAddress.toUpperCase(),
            father_name: formValues.parents.fatherName.toUpperCase(),
            mother_name: formValues.parents.motherMaidenName.toUpperCase(),
            parents_home_address: formValues.parents.homeAddress1.toUpperCase(),
            emergency_contact_name: formValues.emergencyContact.name.toUpperCase(),
            emergency_contact_number: formValues.emergencyContact.contactNumber,
            emergency_contact_address: formValues.emergencyContact.address.toUpperCase(),
            ref_code: formValues.referralCode ? formValues.referralCode.toUpperCase() : null,
            experience_bg: formValues.experience_set?.label || null,
            ass_id: data?.ass_id || null,
            job_position: formValues.jobPosition || null,
        };

        // console.log('Payload:', payload);

        // return

        const response = await APIServices.post({
            url: '/register',
            payload,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            setAlertMsg('');
            localStorage.setItem('access_token', response.data?.token);
            localStorage.setItem('ads_limit', 1);
            dispatch(
                storeUserDetails({
                    id: response?.data?.user_id,
                    name: `${formValues.firstName} ${formValues.lastName}`,
                    email: response?.data?.user?.email,
                    session_key: response?.data?.token,
                    admin_status: response?.data?.user?.admin_status || null,
                    ads_limit: 0,
                })
            );

            //if (formValues.experience_set?.id === '6') { statusUpdate(response?.data?.user_id, 14, 'Applying for Admin Support – Maintenance & Security Position'); }

            navigate('/applicant/data-privacy');
        } else if (response[0]?.status === 400) {
            setAlertMsg({
                type: 'error',
                message: response[0]?.response?.data?.message
            });
        } else if (response[0]?.status === 403) {
            setAlertMsg({
                type: 'error',
                message: response[0]?.response?.data?.message
            });
        } else {
            setAlertMsg({
                type: 'error',
                message: response[0]?.response?.data?.message
            });

        }

    };



    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    return (
        <div className='h-screen w-full bg-slate-100 flex flex-col  justify-center items-center sm:flex-row overflow-y-auto'>
            <AddressPicker
                open={addressPickerOpen}
                onClose={() => setAddressPickerOpen(false)}
                onAddressSelect={handleAddressSelect}
                initialValue={addressFieldToUpdate ? getFieldValue(addressFieldToUpdate) : ''}
            />


            <div className='w-full h-full flex-col p-6 justify-items-center items-center self-center sm:flex hidden sm:items-center sm:justify-center overflow-hidden'>
                {isLoading ? <CircularProgress /> :
                    <img className='h-full w-full object-center rounded-lg shadow-black shadow-md' src={imageSources[currentImageIndex]} alt='Welcome to the Team' />}
            </div>


            <div className='flex flex-col max-w-[700px]  w-full self-center justify-center h-screen pr-4 p-8 gap-2 bg-white shadow-sm'>
                <div className='flex flex-col items-center gap-2'>
                    <AccountCircleIcon sx={{ color: '#556fa8' }} fontSize="large" />
                    <div className='self-center'>
                        <img className="default_logo lazyloaded" src="https://www.sixelevenbpo.com/wp-content/uploads/2020/05/six-eleven-center-logo.png" alt="six-eleven-center-logo" data-ll-status="loaded" />
                    </div>
                </div>
                {
                    id === '1' && <div className='max-w-[600px] w-full flex flex-col self-center gap-3 ml-3 flex-1 overflow-y-auto'>
                        <h1 className='text-xs text-[#556fa8] font-semibold self-center'>Hello! Welcome to the Team</h1>
                        <Divider className="py-3">
                            <Chip
                                label="Personal Information"
                                color="success"
                                variant="outlined"
                            />
                        </Divider>
                        <div className='w-full flex flex-col sm:flex-row items-center justify-between gap-2 my-3 '>
                            <FormControl sx={{ width: '100%' }} autoComplete="off">
                                <span className='mb-3 font-medium text-[#556fa8]'>First Name</span>
                                <TextField
                                    id="firstName"
                                    name="firstName"
                                    type='text'
                                    onKeyPress={(e) => {
                                        if (/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    placeholder="e.g. Juan"

                                    inputProps={{ autoComplete: 'nopill' }}
                                    value={formValues.firstName}
                                    onChange={handleChange}
                                />
                            </FormControl>

                            <FormControl sx={{ width: '100%' }}>
                                <span className='mb-3 font-medium text-[#556fa8]'>Middle Name</span>
                                <TextField
                                    id="middleName"
                                    name="middleName"
                                    type='text'
                                    onKeyPress={(e) => {
                                        if (/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    placeholder="e.g. Santos"
                                    autoComplete="off"
                                    inputProps={{ autoComplete: 'nopill' }}

                                    value={formValues.middleName}
                                    onChange={handleChange}
                                />
                            </FormControl>

                            <FormControl sx={{ width: '100%' }} >
                                <span className='mb-3 font-medium text-[#556fa8]'>Last Name</span>
                                <TextField
                                    id="lastName"
                                    name="lastName"
                                    type='text'
                                    onKeyPress={(e) => {
                                        if (/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    placeholder="e.g. Dela Cruz"
                                    autoComplete="off"
                                    inputProps={{ autoComplete: 'nopill' }}
                                    value={formValues.lastName}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </div>
                        <FormControl sx={{ width: '100%' }}>
                            <span className='mb-3 font-medium text-[#556fa8]'>Phone Number</span>
                            <TextField
                                id="phone-number"
                                name="phoneNumber"
                                type="number"
                                placeholder="e.g. 09123456789" b
                                value={formValues.phoneNumber}
                                onChange={handleChange}
                                onInput={(e) => {
                                    e.target.value = e.target.value.slice(0, 11);
                                }}
                                inputProps={{ autoComplete: 'nopill' }}
                            />
                        </FormControl>

                        <FormControl sx={{ width: '100%' }}>
                            <span className='mb-3 font-medium text-[#556fa8]'>Email</span>
                            <TextField
                                id="email"
                                name="email"
                                type='email'
                                placeholder="e.g. juandelacruz@email.com"
                                value={formValues.email}
                                onChange={handleChange}
                                inputProps={{ autoComplete: 'nopill' }}
                            />
                        </FormControl>

                    </div>
                }

                {(id === '2') &&
                    <div className='max-w-[600px] w-full flex flex-col self-center gap-3 ml-3 flex-1 overflow-y-auto'>
                        <h1 className='text-xs text-[#556fa8] font-semibold self-center'>Hello! Welcome to the Team</h1>

                        <Divider className="py-3">
                            <Chip
                                label="Personal Information"
                                color="success"
                                variant="outlined"
                            />
                        </Divider>
                        <div className='w-full flex flex-col sm:flex-row items-center justify-between gap-2 my-3'>
                            <FormControl sx={{ width: '100%' }}>
                                <span className='mb-3 font-medium text-[#556fa8]'>First Name</span>
                                <TextField
                                    id="first-name"
                                    name="firstName"
                                    type='text'
                                    onKeyPress={(e) => {
                                        if (/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    placeholder="e.g. Juan"
                                    autoComplete="off"
                                    inputProps={{ autoComplete: 'nopill' }}
                                    value={formValues.firstName}
                                    onChange={handleChange}
                                    disabled={data?.ass_id}
                                    helperText=""
                                />
                            </FormControl>

                            <FormControl sx={{ width: '100%' }}>
                                <span className='mb-3 font-medium text-[#556fa8]'>Middle Name</span>
                                <TextField
                                    id="middle-name"
                                    name="middleName"
                                    onKeyPress={(e) => {
                                        if (/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    type='text'
                                    autoComplete="off"
                                    inputProps={{ autoComplete: 'nopill' }}
                                    placeholder="e.g. Santos"
                                    value={formValues.middleName}
                                    onChange={handleChange}
                                    disabled={data?.ass_id}

                                />
                            </FormControl>

                            <FormControl sx={{ width: '100%' }}>
                                <span className='mb-3 font-medium text-[#556fa8]'>Last Name</span>
                                <TextField
                                    id="last-name"
                                    name="lastName"
                                    onKeyPress={(e) => {
                                        if (/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    type='text'
                                    autoComplete="off"
                                    inputProps={{ autoComplete: 'nopill' }}
                                    placeholder="e.g. Dela Cruz"
                                    value={formValues.lastName}
                                    onChange={handleChange}
                                    disabled={data?.ass_id}
                                    helperText=""
                                />
                            </FormControl>



                        </div>
                        <span className='font-light text-sm -my-4'>Middle Name is Optional: leave blank if N/A</span>
                        <div className='w-full grid grid-cols-2 max-md:grid-cols-1 max-lg:grid-cols-2 gap-2 items-center justify-between  my-3'>

                            <FormControl sx={{ width: '100%' }}>
                                <span className='mb-3 font-medium text-[#556fa8]'>Gender</span>
                                <TextField
                                    id="gender-select"
                                    name="gender"
                                    select
                                    value={formValues.gender}
                                    onChange={handleChange}
                                    SelectProps={{
                                        native: true,
                                    }}
                                >
                                    {genderOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </TextField>
                            </FormControl>


                            <FormControl sx={{ width: '100%' }}>
                                <span className='mb-3 font-medium text-[#556fa8]'>Birth Date</span>
                                <TextField
                                    id="birth-date"
                                    name="birthDate"
                                    type='date'
                                    value={formValues.birthDate}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </FormControl>
                            <FormControl sx={{ width: '100%' }}>
                                <span className="mb-3 font-medium text-[#556fa8]">Phone Number</span>
                                <TextField
                                    id="phone-number"
                                    name="phoneNumber"
                                    type="text"
                                    placeholder="e.g. 09123456789"
                                    value={formValues.phoneNumber}
                                    inputProps={{
                                        maxLength: 11,
                                        inputMode: 'numeric',
                                        pattern: '[0-9]*',
                                    }}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, ''); // digits only
                                        setFormValues({
                                            ...formValues,
                                            phoneNumber: value,
                                        });
                                    }}
                                    disabled={data?.ass_id}

                                />
                            </FormControl>

                            <FormControl sx={{ width: '100%' }}>
                                <span className='mb-3 font-medium text-[#556fa8]'>Civil Status</span>
                                <TextField
                                    id="civil-status-select"
                                    name="civilStatus"
                                    select
                                    value={formValues.civilStatus}
                                    onChange={handleChange}
                                    SelectProps={{
                                        native: true,
                                    }}
                                >
                                    {civilStatusOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </TextField>
                            </FormControl>


                        </div>



                        <div className="flex flex-col gap-2">

                            <span className='mb-3 font-medium text-[#556fa8]'>Current Address</span>
                            {!formValues.currentAddress &&
                                <Button variant="outlined" onClick={() => handleOpenAddressPicker('currentAddress')}>Select Address</Button>
                            }
                            {formValues.currentAddress &&
                                <div className='flex flex-row w-full  gap-1'>

                                    <FormControl sx={{ width: '100%', gap: 1 }}>
                                        <TextField
                                            id="current-address"
                                            name="currentAddress"
                                            placeholder="e.g. #23 Mabini St., Brgy. San Roque, Davao City"
                                            value={formValues.currentAddress}
                                            onChange={handleChange}
                                            disabled
                                        />
                                    </FormControl>
                                    <Button className='flex  h-full self-center items-center' variant="outlined" placeholder="Update Address" onClick={() => handleOpenAddressPicker('currentAddress')}>
                                        <GrUpdate />
                                    </Button>
                                </div>


                            }
                        </div>



                        <div className="flex flex-col gap-2">
                            <span className='mb-3 font-medium text-[#556fa8]'>Permanent Address</span>
                            {!formValues.permanentAddress &&
                                <Button variant="outlined" onClick={() => handleOpenAddressPicker('permanentAddress')}>Select Address</Button>
                            }
                            {formValues.permanentAddress &&
                                <div className='flex flex-row w-full  gap-1'>

                                    <FormControl sx={{ width: '100%' }}>
                                        <TextField
                                            id="permanent-address"
                                            name="permanentAddress"
                                            placeholder="e.g. #23 Mabini St., Brgy. San Roque, Davao City"
                                            value={isSameAddress ? formValues.currentAddress : formValues.permanentAddress}
                                            onChange={handleChange}
                                            disabled
                                        />
                                    </FormControl>
                                    <Button className='flex  h-full self-center items-center' variant="outlined" placeholder="Update Address" onClick={() => handleOpenAddressPicker('permanentAddress')} disabled={isSameAddress}>
                                        <GrUpdate />
                                    </Button>
                                </div>
                            }
                            <FormControlLabel
                                control={<Checkbox checked={isSameAddress} onChange={handleSameAddressChange} />}
                                label="My permanent address is the same as my current address."
                            />
                        </div>

                        <Divider className="py-3">
                            <Chip
                                label="Parents Information"
                                color="success"
                                variant="outlined"
                            />
                        </Divider>
                        <FormControl sx={{ width: '100%' }}>
                            <span className="mb-3 font-medium text-[#556fa8]">Father's Name </span>
                            <TextField
                                id="father-name"
                                type="text"
                                placeholder="Firstname Middlename Lastname"
                                name="fatherName"
                                value={formValues.parents.fatherName}
                                onChange={handleParentsChange}
                                autoComplete="off"
                                inputProps={{ autoComplete: 'nopill' }}
                            />
                        </FormControl>

                        <FormControl sx={{ width: '100%' }}>
                            <span className="mb-3 font-medium text-[#556fa8]"> Mother's Maiden Name </span>
                            <TextField
                                id="mother-maiden-name"
                                type="text"
                                placeholder="Firstname Middlename Lastname"
                                name="motherMaidenName"
                                value={formValues.parents.motherMaidenName}
                                onChange={handleParentsChange}
                                autoComplete="off"
                                inputProps={{ autoComplete: 'nopill' }}
                            />
                        </FormControl>

                        <div className="flex flex-col gap-2">
                            <span className="mb-3 font-medium text-[#556fa8]"> Home Address </span>

                            {formValues.parents.homeAddress1 &&
                                <div className='flex flex-row w-full  gap-1'>
                                    <FormControl sx={{ width: '100%' }}>
                                        <TextField
                                            id="home-address-1"
                                            type="text"
                                            placeholder="e.g. #23 Mabini St., Brgy. San Roque, Davao City"
                                            name="homeAddress1"
                                            value={isSameParentAddress ? formValues.currentAddress : formValues.parents.homeAddress1}
                                            onChange={handleParentsChange}
                                            disabled
                                        />
                                    </FormControl>
                                    <Button className='flex  h-full self-center items-center' variant="outlined" placeholder="Update Address" onClick={() => handleOpenAddressPicker('parents.homeAddress1')} disabled={isSameParentAddress}>
                                        <GrUpdate />
                                    </Button>
                                </div>
                            }
                            {(!isSameParentAddress && !formValues.parents.homeAddress1) && < Button variant="outlined" onClick={() => handleOpenAddressPicker('parents.homeAddress1')} disabled={isSameParentAddress}>Select Address</Button>
                            }                        <FormControlLabel
                                control={<Checkbox checked={isSameParentAddress} onChange={handleSameParentAddressChange} />}
                                label="My parent's home address is the same as my current address."
                            />
                        </div>

                        <Divider className="py-3">
                            <Chip
                                label="Emergency Contact"
                                color="success"
                                variant="outlined"
                            />
                        </Divider>

                        <div className="w-full grid grid-cols-1 gap-2">

                            <div className="grid grid-cols-2 max-md:grid-cols-1 gap-2">
                                <FormControl sx={{ width: '100%' }}>
                                    <span className="mb-3 font-medium text-[#556fa8]"> Name </span>
                                    <TextField
                                        id="emergency-name"
                                        type="text"
                                        placeholder="Firstname Lastname"
                                        name="name"
                                        value={formValues.emergencyContact.name}
                                        onChange={handleEmergencyContactChange}
                                        autoComplete="off"
                                        inputProps={{ autoComplete: 'nopill' }}
                                    />
                                </FormControl>

                                <FormControl sx={{ width: '100%' }}>
                                    <span className="mb-3 font-medium text-[#556fa8]">
                                        Contact Number
                                    </span>

                                    <TextField
                                        id="emergency-contactNumber"
                                        name="contactNumber"
                                        type="text"
                                        placeholder="e.g. 09123456789"
                                        value={formValues.emergencyContact.contactNumber}
                                        inputProps={{
                                            maxLength: 11,
                                            inputMode: 'numeric',
                                            pattern: '[0-9]*',
                                        }}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '').slice(0, 11);

                                            handleEmergencyContactChange({
                                                target: {
                                                    name: 'contactNumber',
                                                    value,
                                                },
                                            });
                                        }}
                                    />
                                </FormControl>

                            </div>

                            <div className="flex flex-col gap-2">
                                <span className="mb-3 font-medium text-[#556fa8]"> Address </span>
                                {formValues.emergencyContact.address &&
                                    <div className='flex flex-row w-full  gap-1'>
                                        <FormControl sx={{ width: '100%' }}>
                                            <TextField
                                                id="emergency-address"
                                                type="text"
                                                placeholder="e.g. #23 Mabini St., Brgy. San Roque, Davao City"
                                                name="address"
                                                value={isSameEmergencyAddress ? formValues.currentAddress : formValues.emergencyContact.address}
                                                onChange={handleEmergencyContactChange}
                                                disabled
                                            />
                                        </FormControl>
                                        <Button className='flex  h-full self-center items-center' variant="outlined" placeholder="Update Address" onClick={() => handleOpenAddressPicker('emergencyContact.address')} disabled={isSameEmergencyAddress}>
                                            <GrUpdate />
                                        </Button>
                                    </div>
                                }
                                {(!isSameEmergencyAddress && !formValues.emergencyContact.address) && <Button variant="outlined" onClick={() => handleOpenAddressPicker('emergencyContact.address')} disabled={isSameEmergencyAddress}>Select Address</Button>
                                }
                                <FormControlLabel
                                    control={<Checkbox checked={isSameEmergencyAddress} onChange={handleSameEmergencyAddressChange} />}
                                    label="My emergency contact's address is the same as my current address."
                                />
                            </div>
                        </div>

                        <Divider className="py-3">
                            <Chip
                                label="Account Information"
                                color="success"
                                variant="outlined"
                            />
                        </Divider>
                        <FormControl sx={{ width: '100%' }}>
                            <span className='mb-3 font-medium text-[#556fa8]'>Application Level</span>

                            <TextField
                                id="experience_set"
                                name="experience_set"
                                select
                                SelectProps={{ native: true }}
                                value={formValues.experience_set?.id ?? ""}
                                onChange={handleChangeExperienceSet}
                            >
                                <option value="" disabled>Select Application Level</option>

                                {experienceLevelOptions.map(option => (
                                    <option
                                        key={option.id}
                                        value={option.id}
                                        disabled={option.disabled}
                                    >
                                        {option.label}
                                    </option>
                                ))}
                            </TextField>

                        </FormControl>


                        {parseFloat(formValues.experience_set?.id) === 5 && <FormControl sx={{ width: '100%' }}>
                            <span className='mb-3 font-medium text-[#556fa8]'>Job Position</span>
                            <TextField
                                id="jobPosition"
                                name="jobPosition"
                                type='text'
                                placeholder="WEB DEVELOPER, ACCOUNTING, IT etc."
                                value={formValues.jobPosition}
                                onChange={handleChange}
                            />
                        </FormControl>}


                        <FormControl sx={{ width: '100%' }}>
                            <span className='mb-3 font-medium text-[#556fa8]'>Branch</span>
                            <TextField
                                id="branch"
                                name="branch"
                                select
                                SelectProps={{ native: true }}
                                value={formValues.branch || ''}
                                onChange={handleChange}
                                disabled={branch_id}
                            >
                                {branchOptions.map(option => (
                                    <option
                                        key={option.value}
                                        value={option.value}
                                        disabled={option.disabled}
                                    >
                                        {option.label}
                                    </option>
                                ))}
                            </TextField>
                        </FormControl>



                        <FormControl sx={{ width: '100%' }}>
                            <span className='mb-3 font-medium text-[#556fa8]'>Email</span>
                            <TextField
                                id="email"
                                name="email"
                                type='email'
                                placeholder="e.g. juandelacruz@email.com"
                                value={formValues.email}
                                onChange={handleChange}
                                disabled={data?.ass_id}
                                autoComplete="off"
                                inputProps={{ autoComplete: 'nopill' }}

                            />
                        </FormControl>

                        <FormControl sx={{ width: '100%' }}>
                            <div className='w-full flex flex-row items-center justify-between gap-2 my-3'>
                                <span className='font-medium text-[#556fa8]'>Password</span>
                            </div>
                            <OutlinedInput
                                id="password"
                                name="password"
                                placeholder="Enter your password"
                                type={showPassword ? 'text' : 'password'}
                                value={formValues.password}
                                autoComplete="off"
                                inputProps={{ autoComplete: 'nopill' }}
                                onChange={handleChange}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={
                                                showPassword ? 'hide the password' : 'display the password'
                                            }
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}
                                            edge="end"
                                        >
                                            {showPassword ?
                                                <VisibilityOff sx={{ color: '2e6b1f' }} /> :
                                                <Visibility sx={{ color: '#2e6b1f' }} />
                                            }
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>

                        <FormControl sx={{ width: '100%' }}>
                            <div className='w-full flex flex-row items-center justify-between gap-2 my-3'>
                                <span className='font-medium text-[#556fa8]'>Confirm Password</span>
                            </div>
                            <OutlinedInput
                                id="confirm-password"
                                name="confirmPassword"
                                placeholder="Confirm your password"
                                type={showPassword2 ? 'text' : 'password'}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={
                                                showPassword ? 'hide the password' : 'display the password'
                                            }
                                            onClick={handleClickShowPassword2}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}
                                            edge="end"
                                        >
                                            {showPassword2 ?
                                                <VisibilityOff sx={{ color: '2e6b1f' }} /> :
                                                <Visibility sx={{ color: '#2e6b1f' }} />
                                            }
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>

                        <FormControl sx={{ width: '100%' }}>
                            <span className="mb-3 font-medium text-[#556fa8]">Recruitment Referral Code </span>

                            <TextField
                                id="referral-code"
                                type="text"
                                placeholder="611-XXXX"
                                name="referralCode"
                                value={formValues.referralCode}
                                onChange={handleChange}
                            />
                        </FormControl>

                    </div>}

                <div className='max-w-[700px] flex flex-col px-10 justify-end self-center w-full mt-2 gap-2 flex-end'>
                    {alertmsg && (
                        <Alert severity={alertmsg.type}>
                            {alertmsg.message}
                        </Alert>
                    )}

                    {id === '1' && <div onClick={checkApplicant} className='w-full font-lexend bg-[#388E3C] flex flex-col items-center justify-center rounded py-2 cursor-pointer text-white font-medium hover:bg-[#556fa8]'>
                        <span>Continue Account Registration</span>
                    </div>}


                    {id === '2' && <div onClick={submitForm} className='w-full font-lexend bg-[#388E3C] flex flex-col items-center justify-center rounded py-2 cursor-pointer text-white font-medium hover:bg-[#556fa8]'>
                        <span>Register</span>
                    </div>}

                    <div className='w-full justify-center flex flex-row gap-2'>
                        <span className='text-black font-light text-sm font-lexend'>Already have an account?</span>
                        <span onClick={() => navigate(pageRoutes.LOGIN)} className='text-[#2e6b1f] font-medium font-lexend text-sm cursor-pointer hover:text-green-800'>Login</span>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default RegisterPage
